// Imágenes para compartir (1200×630), generadas por scripts/og-images.js. Llevan versión
// en el nombre porque el deploy las sube con caché inmutable: al regenerarlas con otro
// diseño, se sube la versión allí y aquí.
export const OG_HOME = '/og/og-home-v1.jpg';
export const OG_URBANISMO = '/og/og-urbanismo-v1.jpg';
export const OG_TERRITORIO = '/og/og-territorio-v1.jpg';
